import type { SinkConfig, SinkId, SinkState, SourceId } from '../../../../Flux/Slice/Visualization/VisualizationSliceTypes.js'
import { SINK_REGISTRY, type SinkTypeKey } from './SinkRegistry.js'
import { AddSinkMenu } from '../Sources/AddSinkMenu.js'
import { useState } from 'react'
import Actions, { useDispatch, useSelector } from '../../../../Flux/index.js'
import { visualizationSlice } from '../../../../Flux/Slice/Visualization/VisualizationSlice.js'
import { TrashIcon } from '@heroicons/react/24/outline'
import type { State } from '../../../../Flux/Slice/index.ts'

export function newSinkId(): SinkId {
  return `sink:${Date.now()}-${Math.random().toString(36).slice(2, 7)}` as SinkId
}

interface Props {
  sourceId: SourceId
  isOpen: boolean
}

export function useAddSink(sourceId: SourceId) {
  const dispatch = useDispatch()
  return (type: SinkTypeKey) => {
    const cfg = SINK_REGISTRY[type].makeConfig(newSinkId())
    dispatch(Actions[visualizationSlice.name].registerSink({ sourceId, sinkconfig: cfg }))
  }
}

export default function SinksSidebarPanel({ sourceId, isOpen }: Props) {
  const [menuOpen, setMenuOpen] = useState(false)

  const sinks = useSelector((s: typeof State) => s.visualization.sources[sourceId]?.sinks ?? {})

  const registerNewSink = useAddSink(sourceId)
  const addSink = (type: SinkTypeKey) => {
    registerNewSink(type)
    setMenuOpen(false)
  }
  const dispatch = useDispatch()
  const vizActions = Actions[visualizationSlice.name]

  return (
    <div className={'border rounded p-2'}>
      <div className={'flex items-center justify-center'}>
        <AddSinkMenu
          sourceId={sourceId}
          open={menuOpen && isOpen}
          onToggle={() => setMenuOpen(!menuOpen)}
          onSelect={(kind) => addSink(kind)}
        />
      </div>
      <div className={'max-h-[50vh] overflow-y-auto'}>
        {Object.entries(sinks).map(([id, sink]) => (
          <SingleSinkEntry
            key={id}
            sink={sink}
            onRemove={() => {
              dispatch(vizActions.unregisterSink({ sourceId, sinkId: id as SinkId }))
            }}
          />
        ))}
      </div>
    </div>
  )
}

export function SingleSinkEntry({ sink, onRemove }: { sink: { config: SinkConfig; state?: SinkState }; onRemove: () => void }) {
  return (
    <div className={'border rounded p-1 my-2 flex flex-col gap-1'}>
      <div className={'flex justify-between'}>
        <span className={'text-sm'}>{`${sink.config.title} (${sink.config.kind})`}</span>
        <span className={'text-xs text-gray-600 self-center'}>{SINK_REGISTRY[sink.config.kind].renderMode} </span>
        <button className={'btn btn-error btn-xs btn-ghost'} onClick={() => onRemove()}>
          <TrashIcon className="w-4 h-4" />
        </button>
      </div>
      {/* <span className={'text-sm'}>Type: {sink.config.kind}</span> */}
    </div>
  )
}
